import React from 'react';

const Button = ({ id, forwardRef, src, position }) => {
  return (
    <a-image
      src={src}
      ref={forwardRef}
      material="transparent: true; depthWrite: false; "
      class="clickable"
      id={id}
      width="1"
      height="1"
      scale="0.5 0.5 0.5"
      opacity="0.8"
      position={position}
      animation="
        property: material.opacity;
        to: 1;
        dur: 200;
        startEvents: mouseenter;"
      animation__mouse-leave="
        property: material.opacity;
        to: 0.8;
        dur: 200;
        startEvents: mouseleave;"
    />
  );
};

export default Button;
